




















































































import Vue from "vue";

import iwStreet from "@/encoding/pages/questions/contactinformations/Street.vue";
import iwNumber from "@/encoding/pages/questions/contactinformations/Number.vue";
import iwBox from "@/encoding/pages/questions/contactinformations/Box.vue";
import iwPostalCode from "@/encoding/pages/questions/contactinformations/PostalCode.vue";
import iwLocality from "@/encoding/pages/questions/contactinformations/Locality.vue";
import iwCompanyName from "@/encoding/pages/questions/contactinformations/CompanyName.vue";
import iwVatNumber from "@/encoding/pages/questions/contactinformations/VatNumber.vue";
import iwAccordion from "@/encoding/components/Accordion.vue";
import iwInputRadioGroup from "@/encoding/components/buildingBlocks/InputRadioGroup.vue";
import iwCustomerLanguage from "@/encoding/pages/questions/contactinformations/CustomerLanguage.vue";
import iwCountry from "@/encoding/pages/questions/contactinformations/Country.vue";

import { mapActions, mapGetters } from "vuex";
import { mapState } from "vuex";

export default Vue.extend({
    components: {
        iwStreet: iwStreet,
        iwNumber: iwNumber,
        iwBox: iwBox,
        iwPostalCode: iwPostalCode,
        iwLocality: iwLocality,
        iwCompanyName: iwCompanyName,
        iwVatNumber: iwVatNumber,
        iwAccordion: iwAccordion,
        iwInputRadioGroup: iwInputRadioGroup,
        iwCustomerLanguage: iwCustomerLanguage,
        iwCountry: iwCountry,
    },

    data: function() {
        return {
            isInvoiceFieldsDisplay: false as boolean,
            pathInStoreCustomerName: "customer.name",
            pathInStoreCustomerVatNumber: "customer.vatNumber"
        };
    },

    computed: {
        ...mapState("CustomersModule", ["customerFormError"]),
        ...mapGetters({
            customerApiErrors: "CustomersModule/customerApiErrors",
        }),

        vatError: function(): string | null {

            // Look for a VAT format error coming from the API.
            const hasVatFormatError = (error: Record<string, any>): boolean => error.params.format == "vat-number";
            const vatFormatError = this.customerApiErrors?.find(hasVatFormatError)?.message ?? null;

            if (vatFormatError) {
                return this.$t("vat_number_invalid") as string;
            }

            // Fall back on other errors (or no errors).
            return (this.customerFormError?.vatNumber as string) ?? null;
        },

        hasInvoicingEnabled: function(): boolean {
            return this.$store.getters["FormModule/getValueUI"]("customer.hasInvoicingEnabled") || false;
        },
        addressInBelgium: function(): boolean {
            if(this.$store.getters["FormModule/getValueUI"]("customer.location.address.provided.country")
                && this.$store.getters["FormModule/getValueUI"]("customer.location.address.provided.country") !== "BE") {
                this.toggleInvoiceFieldAccordion(false);
                return false;
            }
            return true;
        },
    },

    mounted: function() {
        if (this.$store.getters["FormModule/getValueUI"]("customer.hasInvoicingEnabled") === null) {
            this.$store.commit("FormModule/addValueUI", {path: "customer.hasInvoicingEnabled", value: false});
        }
    },

    methods: {
        ...mapActions({
            deleteValueUIPath: "FormModule/deleteValueUIPath"
        }),
        toggleInvoiceFieldAccordion: function(value: boolean): void {
            if (value) {
                this.$store.commit("FormModule/addValueUI", {path: "customer.hasInvoicingEnabled", value: true});
                this.isInvoiceFieldsDisplay = true;
            } else {
                this.isInvoiceFieldsDisplay = false;
                this.deleteValueUIPath(this.pathInStoreCustomerName);
                this.deleteValueUIPath(this.pathInStoreCustomerVatNumber);
                this.$store.commit("FormModule/addValueUI", {path: "customer.hasInvoicingEnabled", value: false});
            }
        },
    }
});

